export default () => ({
  storesInfos: {},
});
